export default __webpack_public_path__ + "static/media/type-icon.50f1c677.svg";